import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';
@Component({
  selector: 'app-application-storage-addAzureBlobstorage',
  templateUrl: './addAzureBlobstorage.modal.html'
})

export class AddAzureBlobstorageModal implements OnInit {
  public BlobStorageUrl: string = PKIUrls.BlobStorageUrl;
  @Input('blobstorageConnectionstring') blobstorageConnectionstring!: string;
  @Input('blobstorageConnectionstringActive') blobstorageConnectionstringActive!: string;
  @Output('connectionstring') updatedConnectionstring: EventEmitter<string> = new EventEmitter<string>();
  @Output('close') close = new EventEmitter();

  buttonDisabled: boolean = true;
  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group(
      {
        connectionstring: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
      }
    );
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  back() {
    this.close.emit();
  }

  saveConnectionString() {
    this.updatedConnectionstring.emit(this.blobstorageConnectionstring);
  }

}
